module.exports = __webpack_public_path__ + "img/backimg.027d96e4.jpg";